export default __webpack_public_path__ + "static/media/airdockz-blk-banner-3.6a35737a.jpg";